<mat-menu #menu="matMenu">
  <button mat-menu-item disabled>v. {{ version }}</button>
  <mat-divider></mat-divider>
  <button mat-menu-item routerLink="/reserved/profile">Profile</button>
  <mat-divider></mat-divider>
  <ng-container *awIsInAnyRole="['researcher']">
    <button mat-menu-item routerLink="/reserved/client-download">Download Client</button>
    <mat-divider></mat-divider>
  </ng-container>
  <button (click)="logout()" mat-menu-item>Logout</button>
</mat-menu>


<div class="h-100-vh private-container" fxLayout="column" fxLayoutAlign="start">

  <mat-toolbar color="primary">
    <button (click)="sidenav.toggle()" *awIsInAnyRole="['admin', 'customer', 'logistic', 'tester']"
            aria-label="Example icon-button with menu icon" class="example-icon" mat-icon-button>
      <mat-icon>menu</mat-icon>
    </button>
    <a class="h-100" fxLayout="column" fxLayoutAlign="center center" routerLink="/reserved">
      <img class="toolbar-img-height" src="assets/weseth-logo-trans.png">
    </a>
    <span fxFlex></span>
    <ng-container *awIsAuthenticated="true">
      <button [matMenuTriggerFor]="menu" mat-flat-button>
        <ng-container *ngIf="loggedUser?.lastName && loggedUser?.firstName">{{ loggedUser?.firstName }}
          {{ loggedUser?.lastName }}
        </ng-container>
        <ng-container *ngIf="!loggedUser?.lastName || !loggedUser?.firstName">{{ loggedUser?.email }}</ng-container>
      </button>

      <aw-notifications class="w-max-100-vw"></aw-notifications>

    </ng-container>
    <button mat-icon-button matTooltip="Change theme" (click)="changeTheme()" class="mr-8">
      <ng-container *ngIf="darkTheme">
        <mat-icon>bedtime</mat-icon>
      </ng-container>
      <ng-container *ngIf="!darkTheme">
        <mat-icon>brightness_5</mat-icon>
      </ng-container>
    </button>

  </mat-toolbar>

  <!-- <mat-sidenav-container fxFlex> -->
  <mat-sidenav-container [ngClass]="{'darkBackground': darkTheme, 'lightBackground': !darkTheme}" fxFlex>

    <mat-sidenav #sidenav
                 [opened]="loggedUser.permissions | hasPermission:['admin', 'customer', 'logistic', 'tester']"
                 mode="side">

      <div class="h-100" fxLayout="column">
        <mat-accordion fxFlex>

          <mat-expansion-panel #rlaUsers="routerLinkActive" [expanded]="isActive('/reserved/users')"
                               class="mat-elevation-z0" routerLinkActive>
            <mat-expansion-panel-header *awIsInAnyRole="['admin', 'customer', 'tester']"
                                        [class]="{ 'color-primary': rlaUsers.isActive} ">
              Users
            </mat-expansion-panel-header>
            <mat-nav-list>
              <mat-list-item *awIsInAnyRole="['admin', 'customer', 'tester']" [routerLinkActive]="'color-primary'"
                             routerLink="/reserved/users">
                All Users
              </mat-list-item>
            </mat-nav-list>
          </mat-expansion-panel>

          <mat-expansion-panel #rlaCompanies="routerLinkActive" *awIsInAnyRole="['admin']"
                                [expanded]="router.url === '/reserved/companies'" class="mat-elevation-z0" routerLinkActive>
            <mat-expansion-panel-header *awIsInAnyRole="['admin']"
                            [class]="{ 'color-primary': router.url === '/reserved/companies' }">
              Companies
            </mat-expansion-panel-header>
            <mat-nav-list>
              <mat-list-item *awIsInAnyRole="['admin']" [routerLinkActive]="'color-primary'"
                             routerLink="/reserved/companies">
                All Companies
              </mat-list-item>

            </mat-nav-list>
          </mat-expansion-panel>

          <mat-expansion-panel #rlaStorage="routerLinkActive" *awIsInAnyRole="['admin']"
                               [expanded]="isActive('/reserved/storage')" class="mat-elevation-z0" routerLinkActive>
            <mat-expansion-panel-header *awIsInAnyRole="['admin']"
                                        [class]="{ 'color-primary': rlaStorage.isActive} ">
              Storage
            </mat-expansion-panel-header>
            <mat-nav-list>
              <mat-list-item *awIsInAnyRole="['admin']" [routerLinkActive]="'color-primary'"
                             routerLink="/reserved/storage">
                Storage
              </mat-list-item>
            </mat-nav-list>
          </mat-expansion-panel>


          <mat-expansion-panel #rlaContracts="routerLinkActive"
                               *awIsInAnyRole="['admin', 'customer', 'logistic']"
                               [expanded]="router.url === '/reserved/contracts'"
                               class="mat-elevation-z0" routerLinkActive>
            <mat-expansion-panel-header *awIsInAnyRole="['admin', 'customer', 'logistic', 'tester']"
                                        [class]="{ 'color-primary': router.url === '/reserved/contracts'} ">
              Contracts
            </mat-expansion-panel-header>
            <mat-nav-list>
              <mat-list-item *awIsInAnyRole="['admin', 'customer', 'logistic', 'tester']"
                             [routerLinkActive]="'color-primary'" routerLink="/reserved/contracts">
                All Contracts
              </mat-list-item>
            </mat-nav-list>
          </mat-expansion-panel>


          <mat-expansion-panel #rlaTestbeds="routerLinkActive" *awIsInAnyRole="['admin', 'customer']"
                               [expanded]="isActive('/reserved/testbeds')" class="mat-elevation-z0" routerLinkActive>
            <mat-expansion-panel-header *awIsInAnyRole="['admin', 'customer']"
                                        [class]="{ 'color-primary': rlaTestbeds.isActive} ">
              Testbeds
            </mat-expansion-panel-header>
            <mat-nav-list>
              <mat-list-item *awIsInAnyRole="['admin', 'customer']" [routerLinkActive]="'color-primary'"
                             routerLink="/reserved/testbeds">
                Testbeds
              </mat-list-item>
            </mat-nav-list>
          </mat-expansion-panel>

          <mat-expansion-panel #rlaExecuteTest="routerLinkActive"
                               *awIsInAnyRole="['admin', 'customer', 'tester']"
                                 [expanded]="router.url.includes('/execute') || router.url.includes('/reserved/contracts/')" class="mat-elevation-z0"
                               routerLinkActive>
            <mat-expansion-panel-header *awIsInAnyRole="['admin', 'customer', 'tester']"
                                        [class]="{ 'color-primary': router.url.includes('/execute') || router.url.includes('/reserved/contracts/')} ">
              Execute Test
            </mat-expansion-panel-header>
            <mat-nav-list>
              <mat-list-item *awIsInAnyRole="['admin', 'customer', 'tester']"
                             [routerLinkActive]="'color-primary'"
                             routerLink="/reserved/companies/execute">
                Execute Test
              </mat-list-item>
            </mat-nav-list>
          </mat-expansion-panel>

          <mat-expansion-panel #rlaUploadTest="routerLinkActive" *awIsInAnyRole="['admin', 'customer']"
                               [expanded]="isActive('/reserved/test-image')" class="mat-elevation-z0" routerLinkActive>
            <mat-expansion-panel-header *awIsInAnyRole="['admin', 'customer']"
                                        [class]="{ 'color-primary': rlaUploadTest.isActive} ">
              Upload Test
            </mat-expansion-panel-header>
            <mat-nav-list>
              <mat-list-item *awIsInAnyRole="['admin', 'customer']" [routerLinkActive]="'color-primary'"
                             routerLink="/reserved/test-image">
                Upload Test
              </mat-list-item>
            </mat-nav-list>
          </mat-expansion-panel>


          <mat-expansion-panel #rlaBoxesManagement="routerLinkActive" *awIsInAnyRole="['admin', 'logistic']"
                               [expanded]="isActive('/reserved/boxes-management')" class="mat-elevation-z0"
                               routerLinkActive>
            <mat-expansion-panel-header *awIsInAnyRole="['admin', 'logistic']"
                                        [class]="{ 'color-primary': rlaBoxesManagement.isActive} ">
              Boxes
            </mat-expansion-panel-header>
            <mat-nav-list>
              <mat-list-item *awIsInAnyRole="['admin', 'logistic']" [routerLinkActive]="'color-primary'"
                             routerLink="/reserved/boxes-management/boxes">
                Boxes
              </mat-list-item>
              <mat-list-item *awIsInAnyRole="['admin', 'logistic']" [routerLinkActive]="'color-primary'"
                             routerLink="/reserved/boxes-management/sims">
                Sims
              </mat-list-item>
              <mat-list-item *awIsInAnyRole="['admin', 'logistic']" [routerLinkActive]="'color-primary'"
                             routerLink="/reserved/boxes-management/interfaces">
                Interfaces
              </mat-list-item>
              <mat-list-item *awIsInAnyRole="['admin']" [routerLinkActive]="'color-primary'"
                             routerLink="/reserved/boxes-management/configuration">
                Box configuration
              </mat-list-item>
            </mat-nav-list>
          </mat-expansion-panel>


          <!--          <mat-expansion-panel #rlaInvoices="routerLinkActive"-->
          <!--                               *awIsInAnyRole="['admin']"-->
          <!--                               [expanded]="isActive('/reserved/invoices')"-->
          <!--                               class="mat-elevation-z0" routerLinkActive>-->
          <!--            <mat-expansion-panel-header *awIsInAnyRole="['admin']"-->
          <!--                                        [class]="{ 'color-primary': rlaInvoices.isActive} ">-->
          <!--              Invoices-->
          <!--            </mat-expansion-panel-header>-->
          <!--          </mat-expansion-panel>-->

          <!--          <mat-expansion-panel #rlaBilling="routerLinkActive"-->
          <!--                               *awIsInAnyRole="['admin']"-->
          <!--                               [expanded]="isActive('/reserved/billing')"-->
          <!--                               class="mat-elevation-z0" routerLinkActive>-->
          <!--            <mat-expansion-panel-header *awIsInAnyRole="['admin']"-->
          <!--                                        [class]="{ 'color-primary': rlaBilling.isActive} ">-->
          <!--              Billing setup-->
          <!--            </mat-expansion-panel-header>-->
          <!--            <mat-nav-list>-->
          <!--              <mat-list-item *awIsInAnyRole="['admin']" [routerLinkActive]="'color-primary'"-->
          <!--                             routerLink="/reserved/billing/setup">-->
          <!--                Setup-->
          <!--              </mat-list-item>-->
          <!--              <mat-list-item *awIsInAnyRole="['admin']" [routerLinkActive]="'color-primary'"-->
          <!--                             routerLink="/reserved/billing/items">-->
          <!--                Items-->
          <!--              </mat-list-item>-->
          <!--            </mat-nav-list>-->
          <!--          </mat-expansion-panel>-->

          <!--          <mat-expansion-panel #rlaNotifications="routerLinkActive"-->
          <!--                               *awIsInAnyRole="['admin']"-->
          <!--                               [expanded]="isActive('/reserved/notiications')"-->
          <!--                               class="mat-elevation-z0" routerLinkActive>-->
          <!--            <mat-expansion-panel-header *awIsInAnyRole="['admin']"-->
          <!--                                        [class]="{ 'color-primary': rlaNotifications.isActive} ">-->
          <!--              Notifications-->
          <!--            </mat-expansion-panel-header>-->
          <!--          </mat-expansion-panel>-->


        </mat-accordion>

        <ng-container *ngIf="isChina">
          <a class="bottom-link" href="https://beian.miit.gov.cn/" target="_blank">京ICP备2024060014号-4</a>
        </ng-container>

      </div>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="ph-2_5 pv-1">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>

  </mat-sidenav-container>

</div>
